function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import GeneralEventTrackingDispatcher from '../GeneralEventTrackingDispatcher';
var gtmDispatcherinstance;
var GTMEventDispatcher = /*#__PURE__*/function (_GeneralEventTracking) {
  /*
  * This class is an interface for connecting to GTM.
  * It is responsible for encapsulating all GTM method calls, and exposing general event to the application.
  * Always use the factory getBrazeEventDispatcherInstance to instantiate this class.
  */
  function GTMEventDispatcher(_ref) {
    var userFetcher = _ref.userFetcher;
    _classCallCheck(this, GTMEventDispatcher);
    return _callSuper(this, GTMEventDispatcher, [{
      userFetcher: userFetcher
    }]);
  }
  _inherits(GTMEventDispatcher, _GeneralEventTracking);
  return _createClass(GTMEventDispatcher, [{
    key: "logWithDefaultEventProps",
    value: function logWithDefaultEventProps(eventName, state, extraProperties) {
      var eventProps = {};
      Object.assign(eventProps, this.createMainEventProperties(state));
      Object.assign(eventProps, extraProperties);
      var data = {
        event: eventName,
        event_properties: eventProps
      };
      if (window && window.dataLayer) {
        this.constructor.cleanUpProperties(window.dataLayer);
        window.dataLayer.push(data);
        return;
      }
      if (process.env.NODE_ENV === 'production' && !process.env.SERVER) {
        /* eslint-disable no-console */
        console.warn(new Error('Tried to push data to GTM\'s dataLayer but could not find gtm '), {
          extra: {
            data: data
          }
        });
      }
    }
  }, {
    key: "logWithDefaultProps",
    value: function logWithDefaultProps() {
      console.warn('logWithDefaultProps not implemented');
    }
  }, {
    key: "setUserProperties",
    value: function setUserProperties() {
      console.warn('setUserProperties not implemented');
    }
  }, {
    key: "setDefaultUserProperties",
    value: function setDefaultUserProperties() {
      console.warn('setDefaultUserProperties not implemented');
    }
  }, {
    key: "identify",
    value: function identify() {
      console.warn('identify not implemented');
    }
  }], [{
    key: "cleanUpProperties",
    value: function cleanUpProperties(dataLayer) {
      dataLayer.push({
        event: 'event_properties_cleanup',
        event_properties: undefined
      });
    }
  }]);
}(GeneralEventTrackingDispatcher);
var getGtmEventDispatcherInstance = function getGtmEventDispatcherInstance(userFetcher) {
  /*
  * Factory responsible for generatign a singleton. Only one instance of EventDispatcherHandler must exist at a time.
  */
  if (gtmDispatcherinstance) {
    return gtmDispatcherinstance;
  }
  gtmDispatcherinstance = new GTMEventDispatcher({
    userFetcher: userFetcher
  });
  return gtmDispatcherinstance;
};
export default getGtmEventDispatcherInstance;
export { GTMEventDispatcher };